import React, { useState, useEffect } from 'react';
import './Services.css';
import Card from './Card';
import ServiceDialog from './ServiceDialog';
import servicesData from '../data/services.json';
import { useInView } from 'react-intersection-observer';
import { useAnimation } from 'framer-motion';
import { motion } from 'framer-motion';


export const staggeredVariant = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.2,
    }
  }
}

export const slideUpCard = {
  hidden: { opacity: 0, y: 100 },
  visible: { opacity: 1, y: 0, transition: { type:'spring'},},
};



function Services() {

  const animate = useAnimation();

  const [viewRef, inView] = useInView({
    threshold: 0.1,
    triggerOnce: true,
  });
  

  useEffect(() => {
    if (inView) {
    animate.start('visible');
    }
  }, [animate, inView]);

  const [selectedService, setSelectedService] = useState(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleLearnMore = (service) => {
    setSelectedService(service);
    setIsDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
    setSelectedService(null);
  };

  return (
    <section id="services" className="services"  ref={viewRef}>
      <div className="container"  >
        <h2 className="section-title">Services Overview</h2>
        <p className="section-subtitle">Comprehensive financial solutions tailored to your needs</p>
        <motion.div
  className="services-grid"
  variants={staggeredVariant}
  initial="hidden"
  animate={animate}
>
          {servicesData.map((service) => (
            <motion.div key={service.id} variants={slideUpCard}>
            <Card
              
              header={
                <div className="service-header">
                  <img src={service.icon} alt="" className="service-icon" />
                  <h3>{service.title}</h3>
                </div>
              }
              body={
                <div className="service-body">
                  {service.initialPoints && service.initialPoints.length > 0 ? (
                    <ul className="service-initial-points">
                      {service.initialPoints.map((point, index) => (
                        <li key={index}>{point}</li>
                      ))}
                    </ul>
                  ) : (
                    <p>{service.description.split('\n\n')[0]}</p>
                  )}
                </div>
              }
              footer={
                  <button 
                    className="btn-learn-more"
                    onClick={() => handleLearnMore(service)}
                  >
                    Learn More <img src="/assets/arrow-right.svg" alt="->" color='white' className="arrow-icon" />
                  </button>
              }
            />
            </motion.div>
          ))}
        </motion.div>
      </div>
      <ServiceDialog 
        service={selectedService}
        isOpen={isDialogOpen}
        onClose={handleCloseDialog}
      />
    </section>
  );
}

export default Services;

